var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"box",attrs:{"element-loading-text":"正在进入工单管理后台..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }